import { createSelector } from '@reduxjs/toolkit'

const facilityData = (state) => state.facility

export const selectFacilityData = createSelector([facilityData], (facility) => facility)
